<template>

  <div main class="tools">

      <div itemlist>
        <p>{{$t("advancedTab.funcName")}}</p>
        <el-input class="name" v-model="funcName" :placeholder="$t('advancedTab.funcName')"></el-input>
      </div>

      <!-- <div itemlist>
        功能代表(非必须)
        <el-upload
        class="upload-demo"
        action=""
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
        multiple
        :limit="1"
        :on-exceed="handleExceed"
        :file-list="fileList">
        <el-button size="small" type="primary">上传功能代表图</el-button>
        </el-upload>
      </div> -->

    <div itemlist>
      {{$t("buttonTab.hotkeySet")}}
      <div>
        <el-checkbox-group v-model="auxiliaryKeys">
          <el-checkbox label="Ctrl"></el-checkbox> 
          <el-checkbox label="Shift"></el-checkbox> 
          <el-checkbox label="Alt"></el-checkbox>
          <el-checkbox label="Win"></el-checkbox>
        </el-checkbox-group>

      </div>

      <el-input v-model="key" :placeholder="$t('buttonTab.recordHotkey')"  @keydown.native="handleKeydown" clearable></el-input>
    </div>
  </div>

</template>

<script>

import KeyboardMapConf from '../../theme/keyboard.map.json';
import { ToolsHandle } from '../../utils/tools.js';
// 命令数据功能操作对象
import { CommandHandle } from '../../utils/command_handle.js';
// 导入HIDDIVICE 硬件通讯模块
import { HIDDeviceObj } from '../../asserts/js/hid_device.js';
import '../../asserts/css/box/tools.css';
export default {
  name: 'tools',
  data() {
    return {
      md5:"",
      funcName:"",
      key:"",
      auxiliaryKeys:[]
    }
  },
  methods: 
  {
    editFunc(md5,name,task)
    {
      let context = this;
      var customObjs =  task.split("+");

      //更新UI
      this.md5 = md5;
      this.funcName = name;
      this.key = customObjs[customObjs.length-1];
      this.auxiliaryKeys = customObjs;
      
      this.auxiliaryKeys.pop();
    },
    handleKeydown(e)
    {
        let key = ToolsHandle.getKeyObj(e);
        this.key = key.keyName;

        e.preventDefault();
        return false;
    }

  }
}
</script>